import * as React from 'react';
import { CookieBannerMessage } from '../elements/cookie-banner-message';
export var CookieBannerMessageContext = React.createContext(CookieBannerMessage);
export var CookieBannerMessageProvider = CookieBannerMessageContext.Provider;